// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageHeaderLayout_wrap-24CUW","header":"PageHeaderLayout_header-LAIAn"};